/**
 * @typedef {'primary_home' | 'second_home' | 'former_home' | 'watch_list' | 'friends_or_family_home'} PropertyCategory
 */

/** @type {Readonly<Record<string, PropertyCategory>>} */
export const PROPERTY_CATEGORIES = Object.freeze({
	FORMER_HOME: 'former_home',
	FRIENDS_OR_FAMILY_HOME: 'friends_or_family_home',
	PRIMARY_HOME: 'primary_home',
	SECOND_HOME: 'second_home',
	WATCH_LIST: 'watch_list',
});

export const UNCATEGORIZED_CATEGORY_KEY = 'uncategorized';

/**
 * @param {Readonly<{category?: PropertyCategory | null, isPrimary?: boolean}>} property
 * @returns {PropertyCategory | 'uncategorized'}
 */
export function getPropertyCategory(property) {
	if (property?.category) {
		return property.category;
	}

	if (property?.isPrimary) {
		return PROPERTY_CATEGORIES.PRIMARY_HOME;
	}

	return UNCATEGORIZED_CATEGORY_KEY;
}
